import type { ReactNode } from "react";

import { ReactComponent as CheckIcon } from "assets/images/iconsV2/check.svg";
import { ReactComponent as XIcon } from "assets/images/iconsV2/x-close.svg";
import { classNames } from "helpers/commonHelpers";

export function SheetField({
  testId,
  label,
  value,
  hideInPrint,
}: {
  testId: string;
  label: ReactNode;
  value: ReactNode;
  hideInPrint?: boolean;
}) {
  if (value === null || value === undefined || value === "") return null;
  return (
    <div
      className={classNames("rfv2-review__field", { "hide-during-print": hideInPrint })}
      data-testid={testId}
    >
      <span className="rfv2-review__field-label" data-testid={`${testId}-label`}>
        {label}
      </span>
      <span className="rfv2-review__field-value" data-testid={`${testId}-value`}>
        {value}
      </span>
    </div>
  );
}

export function isAffirmativeStatus(value: string): boolean {
  return !/^\s*no\b/i.test(value.trim());
}

export function StatusWithInstructions({
  testId,
  label,
  positive,
  statusText,
  instructions,
  instructionsTestId,
}: {
  testId: string;
  label: ReactNode;
  positive: boolean;
  statusText: ReactNode;
  instructions?: string;
  instructionsTestId?: string;
}) {
  return (
    <div className="rfv2-review__service_field" data-testid={testId}>
      <span className="rfv2-review__field-label">{label}</span>
      <div className="rfv2-review__req-item">
        {positive ? (
          <CheckIcon className={classNames("rfv2-review__req-icon", "rfv2-review__req-icon--check")} />
        ) : (
          <XIcon className={classNames("rfv2-review__req-icon", "rfv2-review__req-icon--x")} />
        )}
        <div>
          <span className="rfv2-review__req-text">{statusText}</span>
          {instructions && (
            <>
              <br />
              <span className="rfv2-review__req-comment" data-testid={instructionsTestId}>
                {instructions}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export function DetailsSheetSection({
  testId,
  title,
  headerAction,
  children,
}: {
  testId: string;
  title: ReactNode;
  headerAction?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="shipment-details-sheet__section" data-testid={testId}>
      <div className="shipment-details-sheet__section-header">
        <p>{title}</p>
        {headerAction}
      </div>
      <div className="shipment-details-sheet__section-body">{children}</div>
    </section>
  );
}
